'use strict';

var box = {};

exports.__exports = box;
//# sourceMappingURL=box3.cjs.map
